import { apiClient } from 'ext/lib/api';
import {
  AUTH0_CONFIG,
  login,
  getRegionFromHostname,
  getUserInfo,
  getToken,
  getUserAccounts,
} from 'ext/lib/auth/web';
import { REGION_TO_AWS } from 'ext/lib/auth/constants';

export default async function initializeAuth0() {
  const auth = await login();
  const userInfo = await getUserInfo();
  const region = getRegionFromHostname();

  const accountId = userInfo.active_account_user?.account_id;
  const userId = userInfo.id;
  const spoofing = userInfo.is_spoofing ?? false;

  const { endpoints, studioUrl } = AUTH0_CONFIG[region];
  const endpointOverrides = {
    customerApiUrl: endpoints.customerApi,
    appcuesApiUrl: endpoints.appcuesApi,
    imageServiceLambdaUrl: endpoints.imageServiceLambda,
  };

  // If no active account, fetch user accounts and signal that account selection is needed
  if (!accountId) {
    const accounts = await getUserAccounts();

    return {
      needsAccountSelection: true,
      accounts,
      userId,
      region: REGION_TO_AWS[region],
      endpointOverrides,
      studioUrl,
    };
  }

  const client = apiClient({
    getToken,
    getAccountId: () => accountId,
    getEndpointOverrides: () => endpointOverrides,
  });

  const api = await client.getEndpoints();
  const user = await api.getUser(userId);
  const account = await api.getAccount();

  return {
    auth: { ...auth, accountId, userId },
    user: { ...user, isSpoofing: spoofing },
    account,
    endpointOverrides,
    studioUrl,
    region: REGION_TO_AWS[region],
  };
}
